import { render, staticRenderFns } from "./queryRecord.vue?vue&type=template&id=14996c69&scoped=true"
import script from "./queryRecord.vue?vue&type=script&lang=js"
export * from "./queryRecord.vue?vue&type=script&lang=js"
import style0 from "./queryRecord.vue?vue&type=style&index=0&id=14996c69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14996c69",
  null
  
)

export default component.exports